import React from "react";
import styled from "styled-components";
import { TfiClose } from "react-icons/tfi";
import { Loading } from ".";

const ClanSelector = ({
  isOpen,
  onClose,
  clans,
  selectedClanId,
  onSelectClan,
  onSave,
  loading,
  error,
}) => {
  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <Modal onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="close-icon" onClick={onClose}>
          <TfiClose />
        </div>
        <h3>Selecciona un clan</h3>
        {loading ? (
          <Loading />
        ) : error ? (
          <p>Error al cargar los clanes. Intenta más tarde.</p>
        ) : (
          <>
            <div className="clan-list">
              {clans.map((clan) => (
                <div
                  key={clan.clanId}
                  className={`clan-item ${
                    clan.clanId === selectedClanId ? "selected" : ""
                  }`}
                  onClick={() => onSelectClan(clan.clanId)}
                >
                  <img src={clan.image} alt={clan.name} />
                  <span>{clan.name}</span>
                </div>
              ))}
            </div>
            <button className="btn" onClick={onSave}>
              Guardar cambios
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;

  .modal-content {
    background: var(--clr-grey-1);
    padding: 2rem;
    position: relative;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 12px;
    color: black;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);

    .close-icon {
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
      cursor: pointer;
      font-size: 1.5rem;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.2s ease;

      &:hover {
        color: var(--clr-red-light);
        background-color: rgba(255, 0, 0, 0.1);
        transform: rotate(90deg);
      }
    }

    h3 {
      margin-bottom: 2rem;
      font-size: 1.5rem;
      text-align: center;
    }

    .clan-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 1.5rem;
      margin: 1rem 0 2rem;
      padding: 1rem;
      max-height: 50vh;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
      }

      .clan-item {
        cursor: pointer;
        padding: 1rem;
        text-align: center;
        transition: all 0.3s ease;
        border-radius: 12px;
        background: white;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

        img {
          width: 100%;
          max-width: 80px;
          border-radius: 50%;
          margin: 0 auto;
          display: block;
          transition: transform 0.3s ease;
        }

        span {
          margin-top: 0.8rem;
          display: block;
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        &.selected {
          border: 2px solid var(--clr-primary);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

          img {
            transform: scale(1.1);
          }
        }

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);

          img {
            transform: scale(1.1);
          }
        }
      }
    }

    .btn {
      margin: 0 auto;
      display: block;
      padding: 0.8rem 2rem;
      font-size: 1.1rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      transition: all 0.3s ease;
      background: var(--clr-primary);
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      width: auto;
      min-width: 200px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  @media (max-width: 768px) {
    .modal-content {
      padding: 1.5rem;
      margin: 1rem;

      .clan-list {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 1rem;
        padding: 0.5rem;
      }
    }
  }
`;

export default ClanSelector;
